var client;
var google;
let scriptEle = document.createElement("script");
let mapKey = '';

let route = `https://maps.googleapis.com/maps/api/js?key=${getKey()}&libraries=places&language=en&callback=getKey`;
scriptEle.setAttribute("src", route);

let stripeRouteEle = document.createElement("script");
route = 'https://js.stripe.com/v3/';
stripeRouteEle.setAttribute("src", route);

// (function(c,l,a,r,i,t,y){
//     c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
//     t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
//     y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
// })(window, document, "clarity", "script", window.location.href.includes('https://business.recuvery.com/') ? "pr4otxypz4" : "qf8eiobga2");

(function (w, d, s, l, i) {
    w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js'
    }); var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', window.location.href.includes('https://business.recuvery.com/') ? 'GTM-MKBBM9BS' : '');

function getKey() {
    if (window.location.href.includes('.recuvery.com')) {
        mapKey = 'AIzaSyDuayE9g_ErYJHUDNwcELxOoaiidjG4E2k';
    } else {
        mapKey = 'AIzaSyAudUxsyfqNreXJdNllGSnMiyWZqdZHF-I'
    }
    return mapKey;
}
// document.head.appendChild(scriptEle);
document.head.appendChild(stripeRouteEle);